import React, { useCallback, useMemo } from 'react';
import _ from 'lodash';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import {  EntityUtil } from '@xengage/gw-portals-util-js';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import styles from './PropertyPage.module.scss';
import presentationMetadata from './PropertyPage.metadata.json5';
import './PropertyPage.messages';
import ProjectDetailsComponent  from "../../components/Subcomponents/ProjectDetails/ProjectDetailsComponent";



function PropertyPage(props) {
    const { authHeader } = useAuthentication();
    const {
        wizardData, updateWizardData, currentStep, callbackMap, viewModelService
    } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { pageKey } = currentStep;
    // eslint-disable-next-line security/detect-object-injection
    const metadata = presentationMetadata[pageKey];
    const { initialValidation, onValidate } = useValidation('PropertyPage');
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    
    const onNext = useCallback(
        async () => {

            const {productCode} = wizardData.value.baseData;
            // eslint-disable-next-line security/detect-object-injection
            const lobLineName = lineName[productCode];

            wizardData.value = await updateSubmission(lobLineName, 'PropertyPage', wizardData);

            return wizardData;
        },
        [lineName, updateSubmission, wizardData]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(wizardData)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.consTraAndServLine.coverables.locRisks.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'PropertyPage', subVMCopy);
                            
            return wizardData;
        },
        [lineName, wizardData, updateSubmission]
    );

    const addProjectDetails = useCallback(async () => {

            const projectDetailsObj = {
                tempID: EntityUtil.nextId()
            };

            const { _xCenter, _dtoName } = wizardData.lobData.consTraAndServLine.coverables.locRisks;

            const projectDetailsVM = viewModelService.create(projectDetailsObj, _xCenter, _dtoName);
            
            wizardData.lobData.consTraAndServLine.coverables.locRisks.value = wizardData.lobData.consTraAndServLine.coverables.locRisks.value || []
            

            wizardData.lobData.consTraAndServLine.coverables.locRisks.pushElement(
                projectDetailsVM
            );
            updateWizardData(wizardData);
        },
        [wizardData, viewModelService, updateWizardData]
    );

    const projectDetailsOverrides = useMemo(() => {
        const projectDetailsList = _.get(wizardData, 'lobData.consTraAndServLine.coverables.locRisks', []);
        let overrides = [];

        if (!_.isEmpty(projectDetailsList)) {
            overrides = projectDetailsList?.children.map((projectDetail, index) => ({
                    // [`deleteLocationDetails${index}`]: {
                    //     disabled: information.length === 1 ,
                    //     visible: false
                    // }
                    [`projectDetailsComponent${index}`]: {
                        overrideProps: {
                            "@field": {
                                // apply to all fields
                                showRequired: true,
                                labelPosition: "left",
                            },
                        },
                        submissionVM: wizardData,
                        updateWizardData,
                        pathUpdated: `lobData.consTraAndServLine.coverables.locRisks.children[${index}]`,
                        offeringCode: wizardData.value.lobData.consTraAndServLine.selectedOffering_Ext,
                        projectDetailsVM : projectDetail,
                        index,
                        viewModelService
                    }
                }));
        }

        return Object.assign({}, ...overrides);
    }, [updateWizardData, viewModelService, wizardData]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {

        ...projectDetailsOverrides,

        // informationComponent: {
        //     overrideProps: {
        //         "@field": {
        //             // apply to all fields
        //             showRequired: true,
        //             labelPosition: "left",
        //         },
        //     },
        //     submissionVM: wizardData,
        //     updateWizardData,
        //     pathUpdated: "lobData.consTraAndServLine.coverables.propertyDTO.locRisks"
        // },
        // pplLineCoverageComponent : {
        //     wizardData,
        //     updateWizardData,
        //     clausesBasePath: `lobData.consTraAndServLine.lineCoverages.clausesGroups`
        // }
    };

    const resolveCallbackMap = {
        addProjectDetails,
        ...callbackMap
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.content, wizardData, id, path, overrideProps),
        [metadata.content, wizardData, overrideProps]
    );

    const resolveComponentMap = {
        projectDetailsComponent: ProjectDetailsComponent,
        // coveragespagecomponent: CoveragesPageComponent
    };

    const isDisableNext = () => _.get(wizardData, 'lobData.consTraAndServLine.coverables.locRisks').value.length > 0 ? !_.get(wizardData, 'lobData.consTraAndServLine.coverables.locRisks').aspects.subtreeValid : true;

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={isDisableNext()}
            onNext={onNext}
            onSave={onSave}
        >           
        <ViewModelForm
            uiProps={metadata.content}
            model={wizardData}
            onModelChange={updateWizardData}
            callbackMap={resolveCallbackMap}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            componentMap={resolveComponentMap}
            classNameMap={styles}
        />          
        </WizardPage>
    );
}

PropertyPage.propTypes = wizardProps;
export default withViewModelService(PropertyPage);
